import { TweenMax, TimelineMax } from "gsap";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";

import { TextStyleOptions } from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import { ResizeHelper, IDimConfig, LayoutDimData } from "@nolimitcity/slot-game/bin/core/utils/ResizeHelper";
import { Point } from "pixi.js";
import { FontWeight } from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import { StageEvent } from "@nolimitcity/slot-game/bin/core/stage/event/StageEvent";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { GameSetting } from "@nolimitcity/slot-game/bin/core/setting/GameSetting";

class debugBg extends PIXI.Graphics {

    constructor(layout:IDimConfig) {
        super();
        this.beginFill(0x000000, 0.6);
        this.drawRect(0, 0, layout.WIDTH, layout.HEIGHT);
        this.endFill();
    }
}

class debugText extends PIXI.Text {

    constructor(txt:string = "",style?:TextStyleOptions) {
        super(txt, style);
        this.alpha = 0.7
    }
}


export class Speedster {

    protected static readonly layoutDim: IDimConfig = {
        dimOrientation: {
            landscape: {
                scale: new Point(0.75, 0.75),
                position: new Point(260, 150),
                layout: {
                    left: new Point(260, 150),
                    right: new Point(260, 150)
                }
            },
            portrait: {
                scale: new Point(0.75, 0.75),
                position: new Point(260, 150)
            }
        },
        WIDTH: 300,
        HEIGHT: 40,
    };

    protected static readonly  DEFAULT_TXT_STYLE = {
        fontWeight : FontWeight.BOLD,
        fontFamily: "Helvetica",
        align: "center",
        fill: "#FFFFFF",
        fontSize: 34,
        wordWrap: true,
        wordWrapWidth: 500,
        
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 4,
        dropShadowDistance: 4,
    };

    private static globalSpeed:number = 1;
    private static debugCont:PIXI.Container;
    private static deTxt:string = "Current Speed: ";

    private static tl:TimelineMax;

    constructor() { if(GameSetting.isDevMode) Speedster.initSpeedController() }

    private static get currentText():string{
        return this.deTxt + this.globalSpeed;
    }

    private static get DebugText():debugText{
        return <debugText>this.debugCont.children[1];
    }

    protected static initSpeedController():void{
        document.addEventListener("keydown", function (e) {
            var keyCode = e.keyCode;

            let updated:boolean = true;
            switch (keyCode) {
                case 49: // 1
                case 82: // R
                    Speedster.globalSpeed = 1;
                    break;
                case 50:// 2
                    Speedster.globalSpeed = 2;
                    break;
                case 51: // 3
                    Speedster.globalSpeed = 3;
                    break;
                case 52: // 4
                    Speedster.globalSpeed = 4;
                    break;
                case 53: // 5
                    Speedster.globalSpeed = 5;
                    break;
                case 81: // Q
                    Speedster.globalSpeed = 0.1;
                    break;
                case 83: // S
                    Speedster.globalSpeed = Math.max(Speedster.globalSpeed-0.1,0.1)
                    break;
                case 87: // W
                    Speedster.globalSpeed += 0.1;
                    break;
                default:
                    updated = false;
                    break;
            }
            if(updated){
                Speedster.globalSpeed = parseFloat(Speedster.globalSpeed.toFixed(1));
                TweenMax.globalTimeScale(Speedster.globalSpeed);
                Speedster.updateText();                
            }
        }, false);

        this.debugCont = StageManager.stage.addChild(new PIXI.Container());
        this.debugCont.addChild(new debugBg(this.layoutDim))
        this.debugCont.addChild(new debugText(this.currentText,this.DEFAULT_TXT_STYLE))

        EventHandler.addEventListener(this, StageEvent.STAGE_RESIZED, () => this.onStageResized());
        this.onStageResized();
        this.debugCont.alpha = 0;
    }

    protected static updateText():void{
        Speedster.DebugText.text = Speedster.currentText;

        this.tl = Helper.timeLineKiller(this.tl!,new TimelineMax());

        const duration:number = 0.3 * this.globalSpeed;
        const del:number = 0.35 * this.globalSpeed;

        this.tl.fromTo(this.debugCont, duration,{alpha:1},{ alpha:0, delay:del})
        this.tl.play();
    }

    protected static onStageResized():void{
        const layoutdata: LayoutDimData = ResizeHelper.calcDim(this.layoutDim);
        this.debugCont.children.forEach((e) => {
            e.position = layoutdata.position;
            e.scale = layoutdata.scale;
        })
    }
}